<template>
  <footer class="app-footer">
    <div class="footer-container">
      <!-- 左侧公司信息 -->
      <div class="footer-left">
        <div class="footer-logo">
          <img src="@/assets/img/底部LOGO.png" alt="CAREHABI" class="logo" />
        </div>
        <div class="copyright">
          Copyright © CAREHABI Brand 2025
        </div>
        <div class="connect-text">
          CONNECT WITH US
        </div>
      </div>

      <!-- 右侧导航链接 -->
      <div class="footer-right">
        <!-- 产品列 -->
        <div class="footer-column" v-if="false">
          <h3 class="column-title">Products</h3>
          <ul class="column-links">
            <li><a href="#" class="footer-link">Product Bigclass 1</a></li>
            <li><a href="#" class="footer-link">Product Bigclass 2</a></li>
            <li><a href="#" class="footer-link">Product Bigclass 3</a></li>
            <li><a href="#" class="footer-link">Product Bigclass 4</a></li>
            <li><a href="#" class="footer-link">Product Bigclass 5</a></li>
          </ul>
        </div>

        <!-- 最新消息列 -->
        <div class="footer-column" v-if="false">
          <h3 class="column-title">Latest News</h3>
          <ul class="column-links">
            <li><a href="#" class="footer-link">Company news</a></li>
            <li><a href="#" class="footer-link">Industry news</a></li>
            <li><a href="#" class="footer-link">Technological innovation</a></li>
          </ul>
        </div>

        <!-- 关于我们列 -->
        <div class="footer-column">
          <h3 class="column-title">About us</h3>
          <ul class="column-links">
            <li><a href="#" class="footer-link">About us</a></li>
            <li><a href="#" class="footer-link" @click="tapContactUs">Contact us</a></li>
            <li><a href="#" class="footer-link">Feedback</a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { inject } from 'vue'
export default {
  name: 'AppFooter',
  setup() {
    const showContactModal = inject('showContactModal')
    return {
      showContactModal
    }
  },
  methods: {
    tapContactUs() {
      this.showContactModal = true
    }
  }
}
</script>

<script setup>
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: #333333;
  color: white;
  padding: 40px 0;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
}

.footer-left {
  flex: 0 0 200px;
  
  .footer-logo {
    
    .logo {
      height: 80px;
      transform: translateX(-15px);
      width: auto;
      filter: brightness(0) invert(1); // 将LOGO转为白色
    }
  }
  
  .copyright, .connect-text {
    font-size: 12px;
    opacity: 0.8;
    margin-top: 5px;
    font-weight: 600;
  }
}

.footer-right {
  flex: 1;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}

.footer-column {
  flex: 1;
  
  .column-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    text-transform: uppercase;
  }
  
  .column-links {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      margin-bottom: 12px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
    
    .footer-link {
      color: white;
      text-decoration: none;
      font-size: 14px;
      opacity: 0.8;
      transition: opacity 0.3s ease;
      
      &:hover {
        opacity: 1;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    gap: 40px;
  }
  
  .footer-left {
    flex: none;
  }
  
  .footer-right {
    flex-direction: column;
    gap: 30px;
  }
}
</style> 